'use client';

import { useEffect, useState } from 'react';

export default function ReadingProgress() {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const update = () => {
            const scrolled = window.scrollY;
            const total = document.documentElement.scrollHeight - window.innerHeight;
            if (total > 0) {
                setProgress(Math.min((scrolled / total) * 100, 100));
            }
        };

        window.addEventListener('scroll', update, { passive: true });
        return () => window.removeEventListener('scroll', update);
    }, []);

    return (
        <div
            className="fixed top-0 left-0 h-[3px] z-[100] transition-[width] duration-150 ease-out"
            style={{
                width: `${progress}%`,
                background: 'linear-gradient(90deg, var(--color-md-primary), var(--color-md-primary))',
                opacity: progress > 0 ? 1 : 0,
            }}
        />
    );
}
